import { render, staticRenderFns } from "./SummaryReceipt.vue?vue&type=template&id=d8e79a86&scoped=true"
import script from "./SummaryReceipt.vue?vue&type=script&lang=ts"
export * from "./SummaryReceipt.vue?vue&type=script&lang=ts"
import style0 from "./SummaryReceipt.vue?vue&type=style&index=0&id=d8e79a86&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../nguonhangchina/client/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e79a86",
  null
  
)

export default component.exports